import { Component, OnDestroy } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormGroup, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'tonteppich-import',
  templateUrl: './import.component.html',
  styleUrls: ['./import.component.scss']
})
export class ImportComponent implements OnDestroy {

  importForm = new FormGroup({
    productionYear: new FormControl(),
    director: new FormControl(),
    productionCompany: new FormControl(),
    title: new FormControl(),
    genre: new FormControl(),
    id: new FormControl()
  })

  movies;

  private sub: Subscription

  constructor(private db: AngularFirestore) {
    this.sub = this.db.collection('movies').valueChanges().subscribe(data => {
      this.movies = data;
    })
  }

  import() {
    if (this.importForm.get('id').value) {
      this.db.collection('movies').doc(this.importForm.get('id').value).update(this.importForm.value);
    } else {
      this.importForm.get('id').setValue(this.db.createId())
      this.db.collection('movies').doc(this.importForm.get('id').value).set(this.importForm.value)
    }
    this.importForm.reset()
  }

  deleteMovie(id: string) {
    this.db.collection('movies').doc(id).delete();
  }

  edit(movie) {
    if(!('genre' in movie)) {
      movie.genre = ''
    }
    this.importForm.setValue(movie);
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}
